import { Injectable } from '@angular/core';
import { NgbModal }  from '@ng-bootstrap/ng-bootstrap';

import { ApiService }     from '../api/api.service';
import { SessionService } from '../sessions/session.service';
import { TableService }   from '../table/table.service';
import { VendorModel }    from '../vendors/models/vendor';

import { BranchLinkedCompaniesLookupComponent } from './branch-linked-companies-lookup.component';

@Injectable({ providedIn: 'root' })
export class BranchesLiteApiService {
  constructor (
    private apiService: ApiService,
    private ngbModal: NgbModal,
    private sessionService: SessionService,
    private tableService: TableService
  ) {}

  getCustomerInvoices (customerId: string, offset?: number): Promise<any> {


    const cache = this.tableService.getCacheForTable('branchCustomerInvoices');

    return this.apiService.get('/customers/branch_invoice_list', [
      customerId,
      offset || 0,
      cache.paging.pageSize || 5,
      '*',
      '*',
      cache.sorting.field     || 'post_date',
      cache.sorting.direction || 'desc'
    ]);


  }

  getCustomerPayments (customerId: string, offset?: number): Promise<any> {


    const cache = this.tableService.getCacheForTable('customerBranchPayments');

    return this.apiService.get('/customers/branch_payment_list', [
      customerId,
      offset || 0,
      cache.paging.pageSize   || 5,
      cache.sorting.field     || 'post_date',
      cache.sorting.direction || 'desc'
    ]);


  }

  getFranchiseLink (): Promise<any> {


    return this.apiService.get('/franchise_link');


  }

  getFranchiseLinks (): Promise<any> {


    return this.apiService.get('/franchise_links');


  }

  getLinkedCompanies (): Promise<any> {


    return this.apiService.get('/company/branch_index');


  }

  getStats (): Promise<any> {


    return this.apiService.get('multibranch_dashboard/widget_stats');


  }

  getVendorInvoices (vendor: Partial<VendorModel> = {}): Promise<any> {


    const cache = this.tableService.getCacheForTable('branchVendorInvoices');

    return this.apiService.get('/vendors/branch_invoice_list', [
      vendor.id,
      0,
      cache.paging.pageSize || 5,
      '*',
      '*',
      cache.sorting.field     || 'post_date',
      cache.sorting.direction || 'desc'
    ]);


  }

  getVendorPayments (vendor: Partial<VendorModel> = {}): Promise<any> {


    const cache = this.tableService.getCacheForTable('vendorBranchPayments');

    return this.apiService.get('/vendors/branch_payment_list', [
      vendor.id,
      0,
      cache.paging.pageSize   || 5,
      cache.sorting.field     || 'post_date',
      cache.sorting.direction || 'desc'
    ]);


  }

  lookupLinkedCompanies (): Promise<any> {
    return this.getLinkedCompanies().then(companies => {
      const modalRef = this.ngbModal.open(BranchLinkedCompaniesLookupComponent);

      modalRef.componentInstance.companies = companies;

      return modalRef.result;
    });
  }

  saveFranchiseLink (link: any): Promise<any> {
    let response: any;

    return this.apiService.patch('/franchise_link', link, 'franchise_link')
    .then(result => {
      response = result;
      return this.sessionService.refresh();
    })
    .then(() => response);
  }

  transferStock (transfers: any): Promise<any> {


    return this.apiService.post('/product/branch_transfer', transfers);


    };


  }
